import PropTypes from "prop-types";

const defsSys = {
  Dashboard: PropTypes.object,
  Diag: PropTypes.object,
  Smart: PropTypes.object,
  ProbeSetup: PropTypes.object,
  ProbeConfig: PropTypes.object,
  //   ProbeConfigForce: PropTypes.object,
  ApCoverage: PropTypes.object,
  PieChart: PropTypes.object,
  BandwidthOverlapChart: PropTypes.object,
  GoogleMaps: PropTypes.object,
  Logcat: PropTypes.object,
  StepViewer: PropTypes.object,
};

export default defsSys;
